import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useLayoutEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import Footer from "./Components/footer/Footer";
import Header from "./Components/header/Header";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Home from "./pages/home/Home";
import NotFound from "./pages/notFound/NotFound";
import Portfolio from "./pages/portfolio/Portfolio";
import Services from "./pages/services/Services";
import Skills from "./pages/skills/Skills";
import Thought from "./pages/thought/Thought";

// Scroll + AOS wrapper
const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    // Refresh AOS on route change
    AOS.refresh();
  }, [location.pathname]);

  return children;
};

export default function App() {
  useEffect(() => {
    // Initialize AOS on app load
    AOS.init({
      duration: 1000,
      once: true, // Animation runs only once per element
      easing: "ease-in-out",
    });
  }, []);

  return (
    <div className="app">
      <Router>
        <div className="d-body">
          <Header />
          <div className="d-main">
            <Wrapper>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/services" element={<Services />} />
                <Route path="/my-thought" element={<Thought />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/recent-work" element={<Portfolio />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Wrapper>
          </div>
          <Footer />
        </div>
      </Router>
    </div>
  );
}
